<template>
  <SettingServices/>
</template>

<script>
import { SettingServices } from '@/components/index'
export default {
  name: 'setting-services',
  components: {
    SettingServices
  }
}
</script>
